import React from 'react';
import { Navigate, useOutletContext } from 'react-router-dom';
import { DEFAULT_EXAM_FRAME, examsPath } from '../nav';

/** דף הבית מפנה ישירות למסגרת המבחן הראשונה — הניווט למעלה */
const HomeScreen = () => {
  const { isStation = false } = useOutletContext() || {};
  return <Navigate to={examsPath(DEFAULT_EXAM_FRAME, isStation)} replace />;
};

export default HomeScreen;
